<template>
  <b-button-group size="sm">
    <b-button
      v-for="alignValue in allValues"
      @click="handleValue(alignValue)"
      :disabled="disabled"
      :class="{ 'highlighted' : valueDisplayed === alignValue }"
    >
      <i :class="`fa-light fa-align-${alignValue}`" />
    </b-button>
  </b-button-group>
</template>
<script>

function initialData() {
  return {
    valueSelected: null,
  };
}

export default {
  name: 'AlignGroup',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return initialData();
  },
  computed: {
    allValues() {
      return ['left', 'center', 'right'];
    },
    valueDisplayed() {
      return this.valueSelected || this.value;
    },
  },
  methods: {
    handleValue(value) {
      this.valueSelected = value;
      this.$emit('updateValue', value);
    },
  },
};
</script>
<style scoped lang="scss">
.highlighted {
  background-color: $primary;
  color: $white;
}
</style>
